import { Route } from '@angular/router';

import { AddVehicleContainerComponent } from '../add-vehicle-container/add-vehicle-container.component';
import { AddVehicleGuard } from '../guards/add-vehicle.guard';
import { AddVehicleFeatureGuardGuard } from '../services/add-vehicle-feature.guard';
import { UwQuestionsComponent } from '../uw-questions/uw-questions.component';
import { VehicleAgentNotificationConfirmationComponent } from '../vehicle-agent-notification-confirmation/vehicle-agent-notification-confirmation.component';
import { VehicleDriverInfoComponent } from '../vehicle-driver-info/vehicle-driver-info.component';
import { VehicleDriverSelectionComponent } from '../vehicle-driver-selection/vehicle-driver-selection.component';
import { VehicleExpectationSettingComponent } from '../vehicle-expectation-setting/vehicle-expectation-setting.component';
import { VehicleFeatureEquipmentComponent } from '../vehicle-feature-equipment/vehicle-feature-equipment.component';
import { VehicleFuturePaymentScheduleComponent } from '../vehicle-future-payment-schedule/vehicle-future-payment-schedule.component';
import { VehicleGarageAddressComponent } from '../vehicle-garage-address/vehicle-garage-address.component';
import { VehicleLoanInfoComponent } from '../vehicle-loan-info/vehicle-loan-info.component';
import { VehicleOfflineBindComponent } from '../vehicle-offline-bind/vehicle-offline-bind.component';
import { VehiclePurchaseInfoComponent } from '../vehicle-purchase-info/vehicle-purchase-info.component';
import { VehicleQuoteInfoComponent } from '../vehicle-quote-info/vehicle-quote-info.component';
import { VehicleQuoteSummmaryComponent } from '../vehicle-quote-summmary/vehicle-quote-summmary.component';
import { VehicleSecondaryDriverSelectionComponent } from '../vehicle-secondary-driver-selection/vehicle-secondary-driver-selection.component';
import { VehicleUnderwritingQuestionsComponent } from '../vehicle-underwriting-questions/vehicle-underwriting-questions.component';
import { VehicleUseMileageComponent } from '../vehicle-use-mileage/vehicle-use-mileage.component';
import { VehicleVinOdoComponent } from '../vehicle-vin-odo/vehicle-vin-odo.component';
import { AfiVehicleQuoteSummaryComponent } from './../afi-vehicle-quote-summary/afi-vehicle-quote-summary.component';

export const AddVehicleRoutes: Route[] = [
  {
    path: '',
    component: AddVehicleContainerComponent,
    data: {
      breadcrumb: false
    },
    canDeactivate: [AddVehicleFeatureGuardGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'expectation'
      },
      {
        path: 'expectation',
        component: VehicleExpectationSettingComponent
      },
      {
        path: 'year-vin',
        component: VehicleVinOdoComponent
      },
      {
        path: 'year-vin/:id',
        component: VehicleVinOdoComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'purchase-info',
        component: VehiclePurchaseInfoComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'primary-use-info',
        component: VehicleUseMileageComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'garage-address',
        component: VehicleGarageAddressComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'verify-features',
        component: VehicleFeatureEquipmentComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'underwriting-questions',
        component: VehicleUnderwritingQuestionsComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'loan-info',
        component: VehicleLoanInfoComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'driver-info',
        component: VehicleDriverInfoComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'driver-selection',
        component: VehicleDriverSelectionComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'driver-selection-step2',
        component: VehicleSecondaryDriverSelectionComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'quote-info',
        component: VehicleQuoteInfoComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'uw-questions',
        component: UwQuestionsComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'vehicle-future-payments',
        component: VehicleFuturePaymentScheduleComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'quote-summary',
        component: VehicleQuoteSummmaryComponent
      },
      {
        canActivate: [AddVehicleGuard],
        path: 'vehicle-quote-summary',
        component: AfiVehicleQuoteSummaryComponent
      },
      {
        path: 'agent-help',
        component: VehicleOfflineBindComponent
      },
      {
        path: 'agent-notification-confirmation',
        component: VehicleAgentNotificationConfirmationComponent
      }
    ]
  }
];
